import styled from 'styled-components'

export const ContentWrapper = styled.div<{ maxWidth?: string }>`
  background: ${props => props.theme.color.onPrimaryLight};
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 25px;
  max-width: ${props => props.maxWidth || '300px'};
  border-radius: 2px;
`

export const BodyContentWrapper = styled.div`
  padding: 10px 0;
`

export const Text = styled.div`
  color: ${props => props.theme.color.onSurfaceMidEmphasys};
  font-size: 14px;
  margin-bottom: 15px;
`

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 15px;
`

export const Heading = styled.div`
  color: ${props => props.theme.color.onPrimaryDark};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
`
